import { getString } from '@vrw/data'
import { useFlightsSearchParams } from './useFlightsSearchParams'
import { format } from 'date-fns'

export const useSearchSummaryTexts = ({ secondLeg = false } = {}) => {
  const { searchParams } = useFlightsSearchParams()
  const isRoundTrip = searchParams?.form?.date?.to

  let title = getString('redSkySearch.results.search.summary.route.short')
    .replace('{{from}}', searchParams?.form?.departure?.cityName ?? '')
    .replace('{{to}}', searchParams?.form?.destination?.cityName ?? '')

  if (secondLeg) {
    title = getString('redSkySearch.results.search.summary.route.short')
      .replace('{{from}}', searchParams?.form?.destination?.cityName ?? '')
      .replace('{{to}}', searchParams?.form?.departure?.cityName ?? '')
  }

  const dates = [searchParams?.form?.date?.from, searchParams?.form?.date?.to]
    .filter((date) => date !== undefined)
    .map((date) => format(date, 'E, dd MMM'))
    .join(' - ')

  const flightCodes = getString('redSkySearch.results.search.summary.route')
    .replace('{{from}}', searchParams?.form?.departure?.code ?? '')
    .replace('{{to}}', searchParams?.form?.destination?.code ?? '')

  const passengers = Object.entries({
    adults: searchParams?.form?.adults,
    youngAdults: searchParams?.form?.youngAdults,
    children: searchParams?.form?.children,
    infant: searchParams?.form?.infant,
  })
    .filter(([, count]) => count! > 0)
    .map(([type, count]) => {
      const key = `redSkySearch.results.search.summary.${type}.${count! > 1 ? 'other' : 'one'}`
      return getString(key).replace('{{count}}', `${count}`)
    })
    .join(', ')

  const subTitle = ` ${getString(
    `redSkySearch.results.sidesheet.summary.${isRoundTrip ? 'roundtrip' : 'oneway'}`
  )} ${flightCodes} | ${dates} | ${passengers}`

  return {
    title,
    subTitle,
    passengers,
  }
}
